<template>
  <!-- 数据统计时间筛选组件 -->
  <div class="info">
    <div class="content-item">
      <div>
        <p>补充材料</p>
        <p style="color: #999">根据实际审核情况，额外要求商家提供指定的补充资料</p>
      </div>
      <div>
        <el-button v-if="!typeList.includes('supplementary')" type="text" @click="supplementInfo">去填写</el-button>
        <el-button v-if="typeList.includes('supplementary')" class="finish" type="text" @click="supplementInfo"
          >已完成</el-button
        >
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    typeList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },

  watch: {},
  computed: {
    id() {
      return this.$route.query.id;
    },
    subjectName() {
      return this.$route.query.subjectName;
    },
    facilitatorName() {
      return this.$route.query.facilitatorName;
    },
    uuid() {
      return this.$route.query.uuid;
    },
    merchantId() {
      return this.$route.query.merchantId;
    },
    type() {
      return this.$route.query.type;
    },
  },
  methods: {
    supplementInfo() {
      this.$router.push({
        path: '/merchants/supplementInfo',
        query: {
          id: this.id,
          subjectName: this.subjectName,
          facilitatorName: this.facilitatorName,
          type: this.type,
          merchantId: this.merchantId,
          uuid: this.uuid,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info {
  background-color: white;
  box-sizing: border-box;
  padding: 18px 30px 20px 30px;
  .content-item {
    height: 80px;
    border-top: 1px solid #e5e5e5;
    box-sizing: border-box;
    padding: 14px 14px 22px 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    p {
      font-size: 12px;
      font-weight: 500;
      color: #333;
      margin-bottom: 8px;
    }
    .el-icon-arrow-right {
      margin-left: 15px;
    }
  }
  .finish {
    color: #2ba33a;
  }
}
</style>
